module.exports = __webpack_public_path__ + "img/ptp2.0c8d43ad.jpg";